import { LabMDM } from '../../masterdata/models/lab';
import { Channels, ResultSet } from './result-channels';

export class ResultConfigDTO {
    _id: string;
    kitName: string;
    lab: LabMDM;
    cycler: string;
    resultName: string;
    kitNameCyclerResultName: string;
    channelThreshold: Channels[];
    resultSet: ResultSet[];
    version: number;
    isChannelRemoved: boolean;
    active: boolean;
}